import React from "react";
import NewExclusionRuleContent from "../components/exclusionRules/new-exclusionRule-content";

const NewExclusionRule = () => {
  return <NewExclusionRuleContent />;
};

export default NewExclusionRule;
